import { render, staticRenderFns } from "./reviewWorkbenchPage.vue?vue&type=template&id=7bc8d646&scoped=true"
import script from "./reviewWorkbenchPage.vue?vue&type=script&lang=js"
export * from "./reviewWorkbenchPage.vue?vue&type=script&lang=js"
import style0 from "./reviewWorkbenchPage.vue?vue&type=style&index=0&id=7bc8d646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8d646",
  null
  
)

export default component.exports